import React from 'react';
import TopBar from '../Menu/TopBar';
import '../CSS/styles.css';

export default function AIStocksIndexes() {
      
    return (
        <div style={{opacity: 1.0 }}>
            <TopBar/>
            <header>
                <h1>Indexes</h1>
            </header>            
            <main>

<h2>What are the major indices</h2>
<p>The major indices are like the pulse of the stock market, giving us a sense of how the market is performing.<br />
<br />Here are some of the most widely followed indices:</p>

<p>&nbsp;</p>
<p>US Indices</p>
<p>- S&P 500 (SPX):<br />
&nbsp;&nbsp;Tracks the performance of the 500 largest publicly traded companies in the US.</p>
<p>- Dow Jones Industrial Average (DJI):<br />
&nbsp;&nbsp;A price-weighted index of 30 large-cap companies in the US.</p>
<p>- Nasdaq Composite Index (IXIC):<br />
&nbsp;&nbsp;Tracks the performance of all stocks listed on the Nasdaq exchange.</p>

<p>&nbsp;</p>
<p>International Indices</p>
<p>- FTSE 100 (UKX):<br />
&nbsp;&nbsp;Tracks the performance of the 100 largest companies listed on the London Stock Exchange.</p>
<p>- DAX Index (DAX):<br />
&nbsp;&nbsp;Tracks the performance of the 30 largest companies listed on the Frankfurt Stock Exchange.</p>
<p>- Nikkei 225 (NI225):<br />
&nbsp;&nbsp;Tracks the performance of 225 large-cap companies listed on the Tokyo Stock Exchange.</p>

<p>&nbsp;</p>
<p>Other notable indices</p>
<p>- VIX Index (VIX):<br />
&nbsp;&nbsp;Tracks the expected volatility of the S&P 500 Index.</p>
<p>- S&P/TSX Composite Index (TSX):<br />
&nbsp;&nbsp;Tracks the performance of the largest companies listed on the Toronto Stock Exchange.</p>

<p>&nbsp;</p>
<p>These indices provide a snapshot of the market's performance and are widely followed by investors, analysts, and financial media.</p>

<h2>Indexes related to the stock HIVE, as an example</h2>
<p>HIVE Digital Technologies Ltd. (HIVE) is listed on the NASDAQ exchange under the ticker symbol HIVE.<br />
As a result, its performance is closely tied to the NASDAQ Composite Index (IXIC).</p>

<p>&nbsp;</p>
<p>In terms of sector-specific indices, HIVE is classified under the Finance sector,<br />
specifically under Nondepository Credit Institutions.<br />
Therefore, its performance may also be influenced by the overall performance of the Finance sector.</p>

<p>&nbsp;</p>
<p>Some notable indices that HIVE may be related to include:</p>
<p>- NASDAQ Composite Index (IXIC):<br />
&nbsp;&nbsp;A market-capitalization-weighted index of all stocks listed on the NASDAQ exchange.</p>
<p>- S&P 500 Index (SPX):<br />
&nbsp;&nbsp;A market-capitalization-weighted index of the 500 largest publicly traded companies in the US,<br />
&nbsp;&nbsp;&nbsp;although HIVE is not currently a component of this index.</p>
<p>- Dow Jones Industrial Average (DJI):<br />
&nbsp;&nbsp;A price-weighted index of 30 large-cap companies in the US,<br />
&nbsp;&nbsp;although HIVE is not currently a component of this index.</p>

<p>&nbsp;</p>
<p>Keep in mind that HIVE's performance may be influenced by a variety of factors,<br />
including overall market trends, sector-specific trends, and company-specific events.</p>
</main>
        </div>
    )
}